import React from "react";
import {
  SaleformatDateByBusinessPreference,
  truncateCommaSeparatedString,
} from "../../components/common/utlity/utility";
import { useTranslation } from "react-i18next";
import { AWS_URL } from "../../services/http.service";
import { Country, State } from "country-state-city";
const LandscapeTheme2 = ({
  item,
  containerRef,
  businessName,
  phone,
  bussiness,
  darkMode = false,
}) => {
  const { t } = useTranslation();
  const textColor = "#424242";
  const bgColor = "#eff6ff";
  const headerBgColor = "#F2F9FF";
  const borderColor = "#3F4154";
  const cellBgColor = "#eff6ff";

  const businessCountry = bussiness?.country
    ? Country.getCountryByCode(bussiness.country)
    : null;
  const businessState = bussiness?.state
    ? State.getStateByCodeAndCountry(bussiness.state, bussiness.country)
    : null;

  // Customer country/state
  const customerCountry = item?.country
    ? Country.getCountryByCode(item.country)
    : null;
  const customerState = item?.state
    ? State.getStateByCodeAndCountry(item.state, item.country)
    : null;

  // Calculate total GST
  const totalGST = (item?.items || item?.returnitems || []).reduce(
    (sum, itm) => sum + ((itm.finalPrice * itm.igst) / 100 || 0),
    0
  );

  return (
    <div
      style={{ margin: "10px", color: textColor, backgroundColor: bgColor }}
      ref={containerRef}
    >
      <style>{`
      .s1 {  color: ${textColor}; font-family: Arial, sans-serif; font-size: 8.5pt; }
      .s2 {  color: ${textColor}; font-family: Arial, sans-serif; font-size: 12pt; }
      .s3 {  color: ${textColor}; font-family: Arial, sans-serif; font-size: 7.5pt; }
      .s4 { color: #424242; font-family: Arial, sans-serif; font-weight: bold; font-size: 7.5pt; }
      table { border-collapse: collapse; width: 100%; }
      td { border: 1px solid ${borderColor}; vertical-align: top; padding: 3px; }
    `}</style>

      <table>
        <tbody>
          {/* Header */}
          <tr>
            <td
              colSpan={9}
              className="s1"
              style={{ textAlign: "center", backgroundColor: headerBgColor }}
            >
              {t("NEWINVOICE.TAX_INVOICE")}
            </td>
          </tr>

          {/* Business + Invoice Info */}
          <tr>
            <td
              colSpan={2}
              className="s2"
              style={{ backgroundColor: cellBgColor }}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <div
                  style={{
                    width: "32px",
                    height: "32px",
                    borderRadius: "50%",
                    overflow: "hidden",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#f3f3f3",
                  }}
                >
                  <img
                    src={
                      bussiness?.businesslogo
                        ? AWS_URL + bussiness.businesslogo
                        : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3dSEtDvpd9KAn4SdFJVoL0K1lj4Xfc-wVWQ&s"
                    }
                    alt="Logo"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                    // //crossOrigin="anonymous"
                  />
                </div>
                <span>{businessName}</span>
              </div>
              <br />
              <span className="s3">
                {t("NEWINVOICE.PHONE")}: {phone || "0000000000"}
              </span>
              <br />
              <span className="s3">GSTIN: {bussiness?.gstNumber || "N/A"}</span>
              <br />
              <span className="s3">Email: {bussiness?.email || "N/A"}</span>
              <br />
              <span className="s3">
                {bussiness?.firstLine
                  ? `${bussiness.firstLine}, ${businessState?.name || ""}, ${
                      businessCountry?.name || ""
                    }`
                  : "N/A"}
              </span>
            </td>

            <td
              colSpan={7}
              className="s3"
              style={{ backgroundColor: cellBgColor }}
            >
              {t("NEWINVOICE.NO")}: {item.invoiceId} | {t("NEWINVOICE.DATE")}:{" "}
              {SaleformatDateByBusinessPreference(
                item?.saleDate,
                bussiness?.dateFormat
              )}
            </td>
          </tr>

          {/* Customer */}
          <tr>
            <td colSpan={9} className="s3">
              {t("NEWINVOICE.BILL_TO")}: <br />
              {item.customerName} <br />
              {t("NEWINVOICE.CONTACT_NO")}: {item.mobile} <br />
              {t("NEWINVOICE.ADDRESS")}:{" "}
              {item?.address
                ? `${item.address}, ${customerState?.name || ""}, ${
                    customerCountry?.name || ""
                  }`
                : "N/A"}
            </td>
          </tr>

          {/* Items Table Header - Fixed column distribution */}
          <tr style={{ backgroundColor: "#F2F9FF" }}>
            <td className="s4" style={{ width: "5%" }}>
              #
            </td>
            <td className="s4" style={{ width: "20%" }}>
              {t("NEWINVOICE.ITEM_NAME")}
            </td>
            <td className="s4" style={{ width: "10%" }}>
              {t("NEWINVOICE.HSN_SAC")}
            </td>
            <td className="s4" style={{ width: "8%", textAlign: "right" }}>
              {t("NEWINVOICE.QTY")}
            </td>
            <td className="s4" style={{ width: "12%", textAlign: "right" }}>
              {t("NEWINVOICE.PRICE_PER_UNIT")}
            </td>
            <td className="s4" style={{ width: "10%", textAlign: "right" }}>
              {t("NEWINVOICE.DISCOUNT")}
            </td>
            <td className="s4" style={{ width: "10%", textAlign: "right" }}>
              {t("NEWINVOICE.GST")} (%)
            </td>
            <td className="s4" style={{ width: "15%", textAlign: "right" }}>
              {t("NEWINVOICE.AMOUNT")} ({bussiness?.currency})
            </td>
            <td className="s4" style={{ width: "10%", textAlign: "right" }}>
              Total
            </td>
          </tr>
          {(item?.invoiceId?.startsWith("RT")
            ? item?.returnitems
            : item?.items
          )?.map((itm, index) => (
            <tr key={index}>
              <td className="s3">{index + 1}</td>
              <td className="s3">{itm.productName}</td>
              <td className="s3">
                {truncateCommaSeparatedString(itm.hsnNumber) || "N/A"}
              </td>
              <td className="s3" style={{ textAlign: "right" }}>
                {itm.quantity}
              </td>
              <td className="s3" style={{ textAlign: "right" }}>
                {itm.salePrice}
              </td>
              <td className="s3" style={{ textAlign: "right" }}>
                {itm.discount} {bussiness?.currency}
              </td>
              <td className="s3" style={{ textAlign: "right" }}>
                {itm.igst}%
              </td>
              <td className="s3" style={{ textAlign: "right" }}>
                {itm.finalPrice}
              </td>
              <td className="s3" style={{ textAlign: "right" }}>
                {itm.transactionAmount}
              </td>
            </tr>
          ))}

          {/* Summary Rows */}
          <tr>
            <td colSpan={6} className="s3" style={{ textAlign: "left" }}>
              {t("NEWINVOICE.SUB_TOTAL")}:
            </td>
            <td colSpan={3} className="s3" style={{ textAlign: "right" }}>
              {bussiness?.currency} {item.transactionAmount?.toFixed(2)}
            </td>
          </tr>
          {item.cgst > 0 && (
            <tr>
              <td colSpan={6} className="s3" style={{ textAlign: "left" }}>
                {t("TAX_WITHOUT_PERC.CGST")}:
              </td>
              <td colSpan={3} className="s3" style={{ textAlign: "right" }}>
                {bussiness?.currency} {parseFloat(item.cgst).toFixed(2)}
              </td>
            </tr>
          )}
          {item.sgst > 0 && (
            <tr>
              <td colSpan={6} className="s3" style={{ textAlign: "left" }}>
                {t("TAX_WITHOUT_PERC.SGST")}:
              </td>
              <td colSpan={3} className="s3" style={{ textAlign: "right" }}>
                {bussiness?.currency} {parseFloat(item.sgst).toFixed(2)}
              </td>
            </tr>
          )}
          {item.igst > 0 && (
            <tr>
              <td colSpan={6} className="s3" style={{ textAlign: "left" }}>
                {t("TAX_WITHOUT_PERC.IGST")}:
              </td>
              <td colSpan={3} className="s3" style={{ textAlign: "right" }}>
                {bussiness?.currency} {parseFloat(item.igst).toFixed(2)}
              </td>
            </tr>
          )}
          {item.cess > 0 && (
            <tr>
              <td colSpan={6} className="s3" style={{ textAlign: "left" }}>
                {t("TAX_WITHOUT_PERC.CESS")}:
              </td>
              <td colSpan={3} className="s3" style={{ textAlign: "right" }}>
                {bussiness?.currency} {parseFloat(item.cess).toFixed(2)}
              </td>
            </tr>
          )}
          <tr>
            <td colSpan={6} className="s3" style={{ textAlign: "left" }}>
              {t("NEWINVOICE.PAYMENT_MODE")}: {item.paymentMode}
            </td>
            <td colSpan={3} className="s3" style={{ textAlign: "right" }}>
              {t("NEWINVOICE.RECEIVED")}: 0.000
              <br />
              {t("NEWINVOICE.BALANCE")}: {item.transactionAmount?.toFixed(2)}
            </td>
          </tr>
          <tr>
            <td colSpan={9} className="s3" style={{ textAlign: "left" }}>
              {t("NEWINVOICE.TERMS_CONDITIONS")}:
              <br />
              {t("NEWINVOICE.THANKS_MESSAGE")}
            </td>
          </tr>
          <tr>
            <td colSpan={7}>
              {bussiness?.aadharPhoto && (
                <div className="flex w-1/2 p-4 bg-gray-100 rounded-lg">
                  <img
                    src={AWS_URL + bussiness?.aadharPhoto}
                    alt="Payment QR Code"
                    className="w-30 object-contain"
                    // //crossOrigin="anonymous"
                  />
                </div>
              )}
            </td>
            <td colSpan={2} className="s3" style={{ textAlign: "left" }}>
              {t("NEWINVOICE.FOR_COMPANY", { company: businessName })}:
              <br />
              <img
                alt="signature"
                width="88"
                height="34"
                src="data:image/jpg;base64,/9j/4AAQSkZJR..."
              />
              <br />
              {t("NEWINVOICE.AUTHORIZED_SIGNATORY")}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default LandscapeTheme2;
